<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="320"
    open-on-click
  >
    <template v-slot:activator="{ props }">
      <slot v-bind="{ props }" name="activator" />
    </template>

    <div class="vb-dialog vb-dialog-danger">
      <v-card data-cy="dialog-deleteAccessLink-modal">
        <v-card-title class="bg-red-darken-3 d-flex justify-space-between">
        <span>
          {{ $t('routes.pod.menuAccesslink.confirmDeletion') }}
        </span>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-4">
          {{ $t('routes.pod.menuAccesslink.deleteAccesslinkDialogMessage') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btnOk" v-on:click="deleteAccesslink" elevation=0
                 data-cy="dialog-deleteAccessLink-ok">
            {{ $t('common.delete') }}
          </v-btn>
          <v-btn variant="text" @click="dialog = false" class="bntCancel"
                 data-cy="dialog-deleteAccessLink-false">
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { useAccesslinkStore } from '@/stores/AccesslinkStore';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "AccesslinkDeleteDialog",
  props: {
    accesslink: {
      type: Object,
      required: true,
    }
  },
  data: function() {
    return {
      dialog: false,
    };
  },
  methods: {
    deleteAccesslink: async function() {
      const accesslinkStore = useAccesslinkStore();
      try {
        await accesslinkStore.deleteAccesslink(this.accesslink.id);
        this.dialog = false;
      } catch (error) {
        console.error('Error deleting access link:', error);
      }
    }
  },
}
</script>

<style>
</style>
